<script setup lang="ts">
import type { Person } from '~/app/types/person';

interface Props {
  people: Array<Person>;
}

defineProps<Props>();
</script>

<template>
  <div class="c-people-list">
    <PeopleTile v-for="person in people" :key="person._key" :person="person" class="c-people-list__item" />
  </div>
</template>

<style scoped>

.c-people-list {
  width: 100%;
  --gap: 0.75rem;
  --rows: 1;

  @screen tablet-wide {
    --gap: 1.5rem;
    --rows: 2;
  }

  @screen desk {
    --rows: 3;

    @container (max-width: theme('screens.tablet-wide')) {
      --rows: 2;
    }
  }

  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  gap: var(--gap);

  &__item {
    /*
      Calculate width of each item based on the number of rows and the gap between them.
    */
    flex: 0 0 calc(
      calc(100% / var(--rows)) -
      calc(calc(var(--gap) * calc(var(--rows) - 1)) / var(--rows)));  }

    &:deep(img) {
      padding: 0;
    }
}

</style>
